var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-input"},[_c('input',{attrs:{"type":_vm.show?'text':'password',"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}}),_c('div',{staticClass:"pwd-btn",class:{show: _vm.show},on:{"click":function($event){_vm.show=!_vm.show}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }